import { createComponentPreviewEntry } from '@wix/editor-elements-integrations';
import { withComponentPreview } from '@wix/editor-elements-preview-utils';
import React from 'react';
import { YouTubeSubscribeButtonProps } from '../YouTubeSubscribeButton.types';

export default (
  ViewerComponent: React.ComponentType<YouTubeSubscribeButtonProps>,
) => createComponentPreviewEntry(withComponentPreview(ViewerComponent as any));
